import api, { apiSetup } from '../api';

apiSetup();

export class ScopesService {
  BASE_URL = '/scopes';

  get() {
    return api.get(this.BASE_URL);
  }
}
